import React from 'react';
import Gaming from './Gaming';

/** Lab tab — Docker instances for future private AI / custom workloads */
const Lab = () => <Gaming mode="lab" />;

export default Lab;
